module.exports = __webpack_public_path__ + "static/media/acceptance-completed.caae5f86.png";